import { useCallback } from "react";

import { useCreateProject } from "modules/projects/api";

import { useGetCreateSpec, useCreateError, useCreateStatus } from "./store";

export const useGetCreate = () => {
  const createProject = useCreateProject();

  const createSpec = useGetCreateSpec();
  const [, setStatus] = useCreateStatus();
  const [, setError] = useCreateError();

  return useCallback(async () => {
    if (!createSpec) {
      setError("MUST select data, and set outcome");
      return;
    }
    if (createSpec.meta_data.outcomes.length === 0) {
      setError("MUST select data, and set outcome");
      return;
    }
    setStatus("in-progress");
    setError(null);

    const resp = await createProject(createSpec);
    if (resp.success === false) {
      setError(resp.error);
    }
    setStatus("completed");
    return resp;
  }, [createSpec, setStatus, setError]);
};
